<template>
  <div class="page-block">
    <header-bar>エラー</header-bar>
    <div class="page-block__inner">
      <div class="error-block">
        <div class="error-block__title">
          エラーが発生しました。
        </div>
        <div class="error-block__text">
          処理の際にエラーが発生しました。<br>
          しばらく時間を空けてから再度お試し下さい。
        </div>
        <div class="c-btn-wrap">
          <router-link
            :to="{name: 'index'}"
            class="c-text-link">
            TOPへ
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../HeaderBar'

export default {
  name: 'Error',
  components: {
    HeaderBar,
  },
  mounted() {
  },
}
</script>
